import { graphql } from '@apollo/client/react/hoc';
import React, { Fragment } from 'react';
import { compose, mapProps } from 'recompose';
import MultiSelectInput from '@/se/components/inputs/MultiSelectInput';
import { organizationUserOptions } from '../../../graph/users';
import { defaultTo } from 'lodash';

const toSelectOptions = (data, options = []) => (data ? data.map(id => options.find(_ => _.value === id)) : data);
const fromSelectOptions = data => (data ? data.map(({ value }) => value) : data);

const channelBadge = (enabled, label) => {
  const style = {
    fontSize: '0.75em',
    padding: '1px 4px',
    borderRadius: 3,
    marginLeft: 4,
    backgroundColor: enabled ? 'rgba(76, 175, 80, 0.15)' : 'rgba(244, 67, 54, 0.15)',
    color: enabled ? '#4caf50' : '#f44336',
  };
  return <span style={style}>{label}</span>;
};

const formatChannelLabel = ({ label, hasEmail, hasSms, emailEnabled, smsEnabled }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span>{label}</span>
    {hasEmail && channelBadge(emailEnabled, 'Email')}
    {hasSms && channelBadge(smsEnabled, 'SMS')}
    {!hasEmail && !hasSms && <span style={{ fontSize: '0.75em', marginLeft: 4, color: '#f44336' }}>No channels</span>}
  </div>
);

const options = ({ data: { loading, users }, showChannelBadges, ...rest }) => ({
  options: defaultTo(users, []).map(
    ({ id, name, email, notificationNumbers, reportDeliveryEmail, reportDeliverySms }) => ({
      label: `${name} <${email}>`,
      value: id,
      ...(showChannelBadges && {
        hasEmail: !!email,
        hasSms: !!notificationNumbers,
        emailEnabled: reportDeliveryEmail !== false,
        smsEnabled: reportDeliverySms !== false,
      }),
    })
  ),
  showChannelBadges,
  loading,
  ...rest,
});

const ReportRecipients = ({
  name = 'reportRecipients',
  value,
  options,
  onChange,
  loading,
  disabled,
  showChannelBadges,
  menuPortalTarget,
}) => {
  const handleChange = value => onChange(fromSelectOptions(value));

  return (
    <Fragment>
      <MultiSelectInput
        name={name}
        options={options}
        onChange={handleChange}
        value={toSelectOptions(value, options)}
        loading={loading}
        disabled={disabled}
        {...(showChannelBadges && { formatOptionLabel: formatChannelLabel })}
        {...(menuPortalTarget && { menuPortalTarget, menuPosition: 'fixed' })}
      />
    </Fragment>
  );
};

export default compose(graphql(organizationUserOptions), mapProps(options))(ReportRecipients);
